import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributorService } from 'src/app/services/distributor/distributor.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';

@Component({
  selector: 'app-website-distributor',
  templateUrl: './website-distributor.component.html',
  styleUrls: ['./website-distributor.component.scss']
})
export class WebsiteDistributorComponent {
  distributors:any[]=[];
  itemsPerPage = 9;
  originalData: any[] = [];
  hovered: boolean = false;
  hoveredIndex: any;
  
  filteredBrands: any[] = [];
  allCountriesSymbol: any[] = [];
  yearInMarkets: any[] = [];

  showPagination: boolean = true;
  showNoRecordsFounds: boolean = false;
  isPagination: boolean = false;

  page: number = 0;
  currentPage = 0;
  pageSize: number = 10;
  totalCount: number = 0;
  dataSource = new MatTableDataSource<any[]>;
  data: any[] = [];
  totalData = this.data.length;
  paginator!: MatPaginator;

  keyWord: string = '';
  filterObject: any = {}; 
  paginatedItems: { companyName: string, logo: string }[] = [];
  constructor(
  
    private router: Router,
    private readonly route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private spinner: SpinnerService,
    private sharedService: SharedService,
    private distributorService: DistributorService
  ) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const page = parseInt(params['page'], 10);
  
      if (!isNaN(page) && page > 0) {
        this.currentPage = page - 1;
        this.page = this.currentPage;
      } else {
        this.currentPage = 0;
        this.page = this.currentPage;
      }
    this.getAllDistributorsList();
    });
     this.ShowItemsBasedonScreenSize();
    this.spinner.showSpinner();
    this.spinner.hideSpinner();
  }
 

  onPageChanged(paginatedData: any): void {
    this.page = paginatedData[1];
    this.pageSize = paginatedData[2];
    this.itemsPerPage = this.pageSize;
    this.getAllDistributorsList();
  }

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;

      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }
  ShowItemsBasedonScreenSize() {
    this.breakpointObserver.observe([
      '(max-width: 768.98px)'
    ]).subscribe((result: any) => {
      if (result.matches) {
        if (result.breakpoints['(max-width: 768.98px)']) {
         this.resetScrollSettings();
        }
      }
    });
  }
  onReceiveFilterObject(filterObject: any): void {
    this.filterObject = filterObject;
    this.getAllDistributorsList();
  }
  
  viewPortfolio(distributor: any): void {
    this.router.navigate([`website-distributor/brand-profile/${distributor.id}`], {
      queryParams: { type: 'distributor',page: this.currentPage }
    });
  }

  getAllDistributorsList(): void {
    this.spinner.showSpinner();
    this.distributorService.getDistributorsList(this.filterObject, this.keyWord, this.page, this.itemsPerPage).subscribe({
      next: (response) => {
        this.distributors = response.data;
        this.totalCount = response.totalCount;
        this.originalData = this.distributors;
        this.paginatedItems = this.distributors;
        this.spinner.hideSpinner();
      },
      error: (error) => {
      }
    });
  }
  filteredDistributorsData=this.distributors;
  onFilteredDataDistributors(filtered: any): void {
    this.filteredDistributorsData = filtered.data;
    this.distributors = filtered;
    this.paginatedItems = this.filteredDistributorsData;
    this.totalCount = filtered.totalCount;
    if(this.paginatedItems.length == 0){
      this.showNoRecordsFounds = true
    } else {
      this.showNoRecordsFounds = false
    }
  }
  topOfPage(){
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    }else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  changePage(pageIndex: number) {
    this.currentPage = pageIndex;
    this.page = pageIndex; 
    this.getAllDistributorsList();
  
  
    this.topOfPage();
  }

  updateCardData() {
    this.totalData = this.data?.length;
    if (this.paginator) {
      this.paginator.pageIndex = this.currentPage;
      this.dataSource.paginator = this.paginator;
    }
  }
  getTotalPages(): number {
    return Math.ceil(this.totalCount / this.pageSize);
  }

  getPageNumbers(): (number | string)[] {
    const totalPages = this.getTotalPages();
    const pageNumbers: (number | string)[] = [];
  
    if (totalPages <= 5) {
      for (let i = 0; i < totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(0);
      if (this.currentPage > 2) pageNumbers.push('...');
      const start = Math.max(1, this.currentPage - 1);
      const end = Math.min(totalPages - 2, this.currentPage + 1);
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      if (this.currentPage < totalPages - 3) pageNumbers.push('...');
      pageNumbers.push(totalPages - 1);
    }
  
    return pageNumbers;
  }
}
